// @flow

import React from 'react';
import PropTypes from 'prop-types';
import SingleContent from './single';
import './style.css';
type Props = {
    Content: any
};
function ApiDcosContent(props: Props) {
    const { Content } = props;
     
    return (
        <>
            {Content.length >= 2 ? (
                Content.map((Content, index) => (
                    <SingleContent Content={Content} key ={index} />
                ))
            ) : (
                <SingleContent Content={Content} />
            )}
        </>
    );
}
ApiDcosContent.propTypes = {
    Content: PropTypes.any
};
export default ApiDcosContent;
